export default "__VITE_ASSET__DXS3NlRF__"